import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions';
import moment from 'moment';

import camelCase from 'lodash/camelCase';
import differenceBy from 'lodash/differenceBy';

import AbstractMapView from './AbstractMapView';
import { getPorTipo, PulseMarker } from '../components/mapa/Marker';

const UM_MINUTO = 60 * 1000;
class Alertas extends AbstractMapView {
  registerListener() {
    this.props.registerAlertasListeners();
  }

  unregisterListener() {
    this.props.unregisterAlertasListeners();
    this.props.resetAlertas();
  }

  updateMarkersLayer(nextProps) {
    const alertasIgnorados = ['Informativo', 'Ausência'];
    const { filtroAlertas } = nextProps;

    const shouldPulse = layer => moment().diff(moment(layer.data)) < UM_MINUTO;
    const isPulse     = layer => layer.options.id === 'pulse-marker';
    const isTipo      = alerta => (filtroAlertas === 'todos' || camelCase(filtroAlertas) === camelCase(alerta.tipo));
    const isIgnorado  = alerta => alertasIgnorados.indexOf(alerta.tipo) >= 0;

    const alertas = nextProps.alertas.filter(alerta => isTipo(alerta) && !isIgnorado(alerta));
    const alertasAnteriores = this.markerLayers.getLayers().filter(m => !isPulse(m)).map(m => m.options.alerta);
    const entraram = differenceBy(alertas, alertasAnteriores, 'id');
    const sairam = differenceBy(alertasAnteriores, alertas, 'id').map(i => i.id);

    // remove markers.
    this.markerLayers.getLayers().forEach(marker =>
      sairam.indexOf(marker.options.id) >= 0 && this.markerLayers.removeLayer(marker)
    );

    // adiciona markers.
    entraram.forEach(alerta => {
      if (shouldPulse(alerta)) {
        this.markerLayers.addLayer(PulseMarker(alerta.localizacao));
      }

      this.markerLayers.addLayer(getPorTipo(alerta.tipo,alerta.localizacao, {id: alerta.id, alerta}));
    });

    // remove os pulse markers logo apos serem exibidos.
    setTimeout(() => {
      this.markerLayers.getLayers().map(layer => isPulse(layer) && this.markerLayers.removeLayer(layer));
    }, 2000);
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.props.location.pathname === '/alertas') {
      this.props.history.push('/alertas/todos');
    }
  }
}

const mapStateToProps = (state) =>  ({
  alertas: state.alertas,
  filtroAlertas: state.filtroAlertas,
  listeningMarkable: state.listeningAlertas,
  localizacao: state.localizacao,
  localizacaoIsLoading: state.localizacaoIsLoading,
  raio: state.raio,
});
const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Alertas);



// WEBPACK FOOTER //
// ./src/containers/Alertas.js